import React from "react";

const Checkbox = ({ label, ...rest }) => {
  return (
    <div>
      <input type="checkbox" {...rest} />
      <label>{label}</label>
    </div>
  );
};

export default Checkbox;
